import React, { useMemo } from 'react';
import { Stack } from 'new/elements/Stack';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { FormBuilder } from 'new/components/settings/VendorBuilder/FormControlBuilder';
import { InjectAuthParamType } from 'new/components/settings/VendorBuilder/types';
import useAuthParamsInjector from 'new/components/settings/VendorBuilder/AuthConfig/useAuthParamsInjector';

interface ConfigBasicProps {
  index: number;
}

const params = (vendor) =>
  [
    {
      configName: 'basic.username',
      param: {
        name: vendor.name + '.username',
        display_name: 'Username Or API Key',
        description: 'Your username or personal API Key',
        order: 1,
        data_type: 'string',
        config: {
          required: true,
        },
        secured: false,
      },
    },
    {
      configName: 'basic.password',
      param: {
        name: vendor.name + '.password',
        display_name: 'Password',
        description: 'Your password.',
        order: 2,
        data_type: 'string',
        config: {
          required: true,
          type: 'password',
        },
        secured: true,
      },
    },
  ] as InjectAuthParamType[];

export const ConfigBasic = (props: ConfigBasicProps) => {
  const { index } = props;
  const { vendor } = useVendorBuilder();

  const basicParams = useMemo(() => params(vendor), [vendor.name]);

  useAuthParamsInjector(basicParams, index);

  return <Stack></Stack>;
};
